/*!
 * accoridion.js 1.0.0
 *
 * https://github.com/adambalee/accordion.js
 * MIT licensed
 *
 * Copyright (C) 2016 adambalee.com - A project by Adam Balee
 */
(function($) {

    $.fn.accordion = function(options) {
        var container = $(this);

        // Establish our default settings
        var defaults = {
            item         : '.panel',
            title        : '.title',
            content      : '.content',
            showFirst    : true,
            speed        : 400
        };

        var settings = $.extend( {}, defaults, options );

        return this.each( function() {

            // Hide all the accordion content areas
            container.find(settings.content).hide();

            // Show the first accordion content area
            if ( settings.showFirst ) 
            {
                container.find(settings.content).first().slideDown(settings.speed);
                // Add a class of 'open' to the first panel
                container.find(settings.item).first().addClass('open');
            }

            // Add a click event on the .title
            container.find(settings.title).on('click', function() {

                if ( $(this).parent().hasClass('open') ) 
                {
                    $(this).parent().removeClass('open');
                    $(this).next(settings.content).slideUp(settings.speed);
                } 
                else 
                {
                    container.find(settings.content).slideUp(settings.speed);
                    container.find(settings.item).removeClass('open');
                    $(this).parent().addClass('open');
                    $(this).next(settings.content).slideDown(settings.speed);
                }

            });

        });

    };

})(jQuery);